export var EarmarkShapes;
(function (EarmarkShapes) {
    EarmarkShapes["POLYGON"] = "polygon";
    EarmarkShapes["RECTANGLE"] = "rect";
    EarmarkShapes["RECTANGLE_NAMED_TILE"] = "rect_named_tile";
})(EarmarkShapes || (EarmarkShapes = {}));
//# sourceMappingURL=EarmarkShapes.js.map